import React, { ReactElement } from 'react';
import { Route, Switch } from 'react-router-dom';
import Layout from '~Layout';
import Broker from './Broker';
import Dashboard from './Dashboard';
import List from './List';
import Map from './Map';
import HubspotErrors from './HubspotErrors';
import { useSelector } from 'react-redux';
import IAuthUser from '~Auth/IAuthUser';
import { authCurrentUserSelector } from '~Auth/selectors';
import PermissionsEnum from '~Api/Administrator/PermissionsEnum';

export default function Router(): ReactElement {
    const currentUser: IAuthUser = useSelector(authCurrentUserSelector);

    return (
        <Layout topSection='brokers'>
            <Switch>
                <Route exact={true} path='/brokers' component={Dashboard} />
                {currentUser.permissions.includes(PermissionsEnum.BrokersHubspotErrors) && <Route exact={true} path='/brokers/hubspot-errors' component={HubspotErrors} />}
                <Route exact={true} path='/brokers/list' component={List} />
                <Route exact={true} path='/brokers/map' component={Map} />
                <Route path='/brokers/:brokerUuid' component={Broker} />
            </Switch>
        </Layout>
    );
}
